<template lang="html">
  <div class="main-container">

    <div>
      <breadcrumb :list="breadcrumbList" />
    </div>

    <section class="main-content-section">
      <tl-tabs :tabs="tabs">
        <tl-tab>
          <uploadAcknowledgement></uploadAcknowledgement>
        </tl-tab>
        <tl-tab>
          <acknowledgementHistory></acknowledgementHistory>
        </tl-tab>
      </tl-tabs>
    </section>


    <div class="content-margin">
      <!-- <div class="upload">
                <p></p>
                <p>Drag & drop files here</p>
                <p>Or</p>
                <div class="upload-button">
                    <img src="@/assets/logout-copy-2_2@2x.png" alt>
                    <label for="upload-photo">Browse</label>
                    <input type="file" name="photo" id="upload-photo">
                </div>
            </div> -->
    </div>


    <!-- Quarter modal -->
    <div class="modal custom-modal" v-if="showQuarterModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <h3>Quarter 1</h3>
        </div>
        <div class="modal-body">

          <div class="justify-content-center">
            <div class="singleColumnGrid grid-allignemnt">
              <txt class="width-400" autofocus="autofocus" label="Enter acknowledgement number" type="text" v-model='formData.acknowledgementNumber'
                name="acknowledgementNumber" v-validate="'required'" :classname="errors.has('acknowledgementNumber')" :errormsg="errors.first('acknowledgementNumber')"
              />
              <txt class="width-400" autofocus="autofocus" label="Enter PRN number" type="text" v-model='formData.prnNumber' name="prnNumber"
                v-validate="'required'" :classname="errors.has('prnNumber')" :errormsg="errors.first('prnNumber')" />
            </div>
          </div>

          <div class="row modal-bottom-buttons paddingtop-10p">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="cancelQuarterModal" />
              <btn text="Save" type="primary" @click="saveQuarterModal" />
            </btn-grp>
          </div>
        </div>
      </div>
    </div>
    <!-- Quarter modal -->

    <!-- Success modal -->
    <pop-up-message v-if="showSuccessMsg" :message="`Quarter 1 Updated Successfully.`" btnText="Back" @back="backfrompopup()"
    />
    <!-- Success modal -->

  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";
  import uploadAcknowledgement from "./uploadAcknowledgement.vue";
  import acknowledgementHistory from "./acknowledgementHistory.vue";

  export default {
    name: "form24Qacknowledgement",
    components: {
      uploadAcknowledgement,
      acknowledgementHistory
    },
    computed: {
      ...mapState({}),
      ...mapGetters({
        getleid: "onboard/legal_entities/legal_entity_ID"
      }),

    },
    data() {
      return {
        breadcrumbList: [
          {
            name: "Organisation",
            url: "/dashboard/0/organisation"
          },
          {
            name: "Utilities",
            url: "/dashboard/0/organisation/utilities"
          },
          {
            name: "Update form 24 Q acknowledgement",
            url: ""
          }
        ],
        tabs: [
          {
            header: "Upload Acknowledgement"
          },
          {
            header: "Acknowledgement History"
          }
        ],
        showQuarterModal: false,
        showSuccessMsg: false,
        quarterList: ["Q 1", "Q 2", "Q 3"],
        formData: {
          quarterValue: "",
          acknowledgementNumber: "",
          prnNumber: ""
        },
        payGroupData: [
          {
            id: 1,
            quarters: "Q 1",
            acknowledgementNumber: "ack 11bgd3",
            prnNumber: "214675",
            fromMonth: "April",
            toMonth: "June",
            attachments: [{ filename: "atch1.png" }],
            fileType: ""
          },
          {
            id: 2,
            quarters: "Q 1",
            acknowledgementNumber: "ack 11bgd3",
            prnNumber: "214675",
            fromMonth: "April",
            toMonth: "June",
            attachments: [{ filename: "atch1.png" }],
            fileType: "Original"
          },
          {
            id: 3,
            quarters: "Q 1",
            acknowledgementNumber: "ack 11bgd3",
            prnNumber: "214675",
            fromMonth: "April",
            toMonth: "June",
            attachments: [{ filename: "atch1.png" }],
            fileType: ""
          },
          {
            id: 4,
            quarters: "Q 1",
            acknowledgementNumber: "ack 11bgd3",
            prnNumber: "214675",
            fromMonth: "April",
            toMonth: "June",
            attachments: [],
            fileType: ""
          }
        ],
        payGroupDataColumns: [
          {
            label: "Quarters",
            key: "quarters"
          },
          {
            label: "Acknowledgement Number",
            key: "acknowledgementNumber"
          },
          {
            label: "PRN Number",
            key: "prnNumber"
          },
          {
            label: "From Month",
            key: "fromMonth"
          },
          {
            label: "To Month",
            key: "toMonth"
          },
          {
            label: "Attachements",
            key: "attachments"
          },
          {
            label: "",
            key: "fileType"
          }
        ]
      };
    },
    mounted() { },

    

    methods: {
      ...mapActions({
        
      }),

      

      routeToMainStep() { },
      routeToSubStep() { },

      initEditStart() {
        //console.log("initEditStart:");
        this.showQuarterModal = true;
      },

      deleteItem() {
        //console.log("deleteItem:");
      },

      saveForm24Qacknowledgement() { },

      cancelQuarterModal() {
        this.showQuarterModal = false;
      },

      saveQuarterModal() {
        this.showQuarterModal = false;
        this.showSuccessMsg = true;
      },

      backfrompopup() {
        this.showSuccessMsg = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .top-padding-20 {
    padding: 20px 0px 0px;
  }

  .top-padding-30 {
    padding: 30px 0px 0px;
  }

  .upload {
    display: flex;
    width: 25%;
    margin-top: 1%;
    flex-direction: column;
    align-items: center;
    background: linear-gradient( to right,
    lightgray 10px,
    rgba(255, 255, 255, 0) 0%),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%);
    background-position: top, right, bottom, left;
    background-repeat: repeat-x, repeat-y;
    background-size: 20px 1px, 1px 20px;
    height: 140px;
  }

  .upload-button {
    display: flex;
    align-items: center;
    label {
      cursor: pointer;
      border: 1px solid #5d409f;
      border-radius: 4px;
      padding: 6px 12px;
      font-size: 15px;
      color: #5d409f;
    }
    #upload-photo {
      opacity: 0;
      position: absolute;
      z-index: -1;
    }
    img {
      height: 19px;
      width: 19px;
      margin-right: 8px;
    }
  }

  .modal-bottom-buttons {
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  .width-80 {
    width: 80%;
  }

  .grid-allignemnt {
    width: 122%;
    justify-content: center;
  }

  .width-400 {
    width: 400px;
  }

  .threeColumnGrid {
    display: grid;
    grid-template-columns: 25% auto auto;
    grid-row-gap: 15px;
    grid-column-gap: 20px;
  }

  .subtitle {
    width: auto;
  }

  .margintop {
    margin-top: 2.5%;
  }

  .header.header1 {
    padding-bottom: 0px;
  }

  .content-margin {
    margin-top: 3.1%;
  }

  .save-margin {
    margin-top: 2.9%;
  }

  .table-margin {
    margin-top: 3.1%;
  }
</style>